import { render, staticRenderFns } from "./co-view-page.vue?vue&type=template&id=1185532b&"
import script from "./co-view-page.vue?vue&type=script&lang=ts&"
export * from "./co-view-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports